// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const removeFromAudit = itemToRemove => ({
    itemToRemove,
    type: actions.REMOVE_CLAIM_FROM_TCSM_AUDIT
});



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/remove-from-audit.js